import React from 'react';
import Image from 'next/image';

const ContactUsPart = props => {
  return (
    <>
      <style jsx global>{`
        .borderedElement::after {
          content: '';
          position: absolute;
          height: 0;
          width: 360px;
          border: 1px solid white;
          top: 20px;
          left: 35px;
        }
        .borderedElement::before {
          content: '';
          position: absolute;
          position: absolute;
          height: 0;
          width: 360px;
          border: 1px solid white;
          bottom: 20px;
          left: 165px;
        }
        @keyframes pulse {
          0% {
            opacity: 0;
            background-position: center top;
            background-size: 0 auto;
          }
          10% {
            opacity: 0;
          }
          50% {
            opacity: 1;
            background-size: 75% auto;
          }
          90% {
            opacity: 0;
          }
          100% {
            opacity: 0;
            background-position: center bottom;
            background-size: 0 auto;
          }
        }
        .filterClose {
          border-bottom: 1px solid rgb(0 0 0 / 5%);
        }

        .perspective-1000 {
          perspective: 1000px;
          display: inline-flex;
          width: 154px;
          height: 40px;
        }
        .perspective-1000 a {
          transform-style: preserve-3d;
          transform: translateZ(-0px);
          transition: transform 0.25s;
        }
        .findUsContactNew {
          width: 191px;
          height: 40px;
          line-height: 40px;
          cursor: pointer;
        }
        //   .findUsContact :before,
        // .findUsContact :after{
        //     content: "Schedule a Call";
        //     height: 40px;
        //     width: 154px;
        //     position: absolute;
        //     display: flex;
        //     align-items: center;
        //     justify-content: center;
        //     border: 1px solid #670F7A!important;
        //     box-sizing: border-box;
        //     border-radius: 5px;
        //     color: #fff;
        //     font-size:18px
        //
        // }
        .findUsContact :before {
          background: #670f7a !important;
          transform: rotateY(0deg) translateZ(15px);
        }
        .findUsContact :after {
          font-weight: 400;
          color: #670f7a !important;
          transform: rotateX(90deg) translateZ(15px);
        }
        // .findUsContact :hover{
        //      transform: translateZ(-15px) rotateX(-90deg);
        //  }
        @media screen and (max-width: 1000px) {
          .borderedElement::before {
            content: unset;
          }
          .borderedElement::after {
            top: 66px;
            width: 80%;
            left: 20px;
          }
          .borderedElement {
            margin-top: 30px;
          }
          .mediaELement {
            bottom: 0px;
            background: url(/images/design/contactmobile.svg);
            background-size: contain;
            background-position: bottom;
            height: 120px;
            padding-top: 20px;
          }
        }
      `}</style>
      <div className="green-path  relative bg-green w-full h-238 md:h-95">
        <div className="container relative borderedElement text-left flex align-center leading-29 md:leading-95 text-white font-bolder text-24 uppercase justify-start  ">
          {props.question}
        </div>
      </div>
      <div className={'w-full h-95 absolute right-0  mediaELement     text-95'}>
        <div className="hidden md:block absolute right-0">
          <Image src={'/images/design/contact.svg'} width={668} height={95} alt={'contact'} />
        </div>
        <div className="w-full relative container  contactInfo top-30 pr-10 text-center md:text-right  ">
          {/* <a className="inline-block w-191   bg-white md:bg-purple hover:text-purple  hover:bg-transparent transition-all transition-400 text-black md:text-white md:text-white px-15 py-7 text-16 rounded-md font-normal md:font-bold md:font-bolder  capitalize text-center   border border-transparent md:border-purple  mr-15"
                       href= {props.link} target="_blank">Contact us</a> */}
          <span className="perspective-1000  ">
            <a
              href={props.link}
              target="_blank"
              className={'findUsContactNew bg-purple rounded-5 text-white flex items-enter justify-center relative '}
            >
              Contact Us
            </a>
          </span>
        </div>
      </div>
      <style jsx global>{`
        .green-path {
          clip-path: polygon(0 0, 75% 0, 70% 100%, 0% 100%);
        }
        @media screen and (max-width: 1000px) {
          .green-path {
            clip-path: unset;
          }
        }
      `}</style>
    </>
  );
};
export default ContactUsPart;
